<template>
  

  <div class="container">
    <hr/>
    <form name="form" @submit.prevent="handleSave">
         <ServicoContr :teste.sync="teste"/> 
         <button class="btn btn-primary btn-block" >
                    
                    <span>Gravar</span>
                  </button>
    </form>
   <!-- <div class="user-container">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-6">
              <h3 class="panel-title">Serviços</h3>
            </div>
          </div>
        </div>
        <div class="card-body">
          <DataTable :value="servicoList" :filters="filters" :paginator="true" :rows="10">
            <template #header>
              <div style="text-align: right">
                <i class="pi pi-search" style="margin: 4px 4px 0px 0px;"></i>
                <InputText v-model="filters['global']" placeholder="Global Search" size="50" />
              </div>
            </template>
            <Column field="codigoServico" header="Codigo"></Column>
            <Column field="nomeServico" header="Nome"></Column>
            <Column field="descricaoServico" header="Descrição"></Column>
            
          </DataTable>
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>

import ServicosService from "../services//tributario/servicos.service";
import ServicoContr from "../views/ServicoContr";

export default {
  name: "servico",
  components:{
    ServicoContr
  },
  data() {
    return {
      teste: null,
      filters: {},
        servicoList: []
    };
  },
  created() {
    ServicosService.findAllServicos().then(servico => {
      this.servicoList = servico.data;
    });
  },
  methods: {
    handleSave() {
      console.log(this.teste)
    }
  }
};
</script>
<style>
</style>

